import { Component, OnInit, Output, Input, ViewChild, EventEmitter, OnChanges, AfterViewInit } from '@angular/core';
import { ValueRangeFilterSetting, ValueRangeFilter } from '@model';

import { MatMenuTrigger } from '@angular/material/menu';
import { String } from 'typescript-string-operations';
import { ToLocalStringPipe } from '@utils/pipes';
import { RegisterFilter } from '@core/filter.registry';
import { BaseFilterComponent } from '@core/components/base-filter/base-filter.component';
import { FilterDefinition } from '@model';

@RegisterFilter
@Component({
    selector: 'app-value-range-filter-pane',
    templateUrl: './value-range-filter-pane.component.html',
    standalone: false
})
export class ValueRangeFilterPaneComponent extends BaseFilterComponent implements OnInit, OnChanges, AfterViewInit {
  @Output()
  value: Array<number>;

  @Output()
  valueChanged = new EventEmitter<FilterDefinition>();

  @Input()
  filter: FilterDefinition;

  @Input()
  typeLabel = '';

  @ViewChild('menuButton', { static: true })
  menuTrigger: MatMenuTrigger;

  @ViewChild('sliderElement', { static: true })

  componentName = 'ValueRangeFilterPaneComponent';

  fromValue: number;
  toValue: number;
  min: number;
  max: number;
  grid_snap: number;
  step: number;
  _label: string;
  isInitialized = false;
  showSelected = false;

  isChanged: boolean;

  constructor(private toLocal: ToLocalStringPipe) {
    super();
  }

  ngOnInit() {
    if (this.filter && this.filter.valueRangeFilter) {
      // Any to/from selected
      if (this.filter.valueRangeFilter.fromValue || this.filter.valueRangeFilter.toValue) {
        this.fromValue = this.filter.valueRangeFilter.fromValue ? this.filter.valueRangeFilter.fromValue : this.filter.valueRangeFilter.min;
        this.toValue = this.filter.valueRangeFilter.toValue ? this.filter.valueRangeFilter.toValue : this.filter.valueRangeFilter.max;
      }
     
      this.min = this.filter.valueRangeFilter.min;
      this.max = this.filter.valueRangeFilter.max;
      this.grid_snap = this.filter.valueRangeFilter.grid_snap;
      this.step = this.filter.valueRangeFilter.step;

      this.isChanged = this.setIsChanged(this.fromValue, this.toValue, this.min, this.max);
      this.setLabel(this.isChanged);
    }
  }

  ngOnChanges() {
    if (this.filter) {
      this.fromValue = this.filter.valueRangeFilter.fromValue;
      this.toValue = this.filter.valueRangeFilter.toValue;
      this.min = this.filter.valueRangeFilter.min;
      this.max = this.filter.valueRangeFilter.max;
    }
    if (!this.isInitialized) {
      return;
    }
    this.setvaluesAndSliderPositions();

    this.isChanged = this.setIsChanged(this.fromValue, this.toValue, this.min, this.max);
    this.setLabel(this.isChanged);
  }

  panelOpened(showSelected: boolean) {
    this.showSelected = false;
  }

  panelClosed(showSelected: boolean) {
    this.showSelected = true;
  
    this.restrictMinValue(null, this.fromValue, this.min, this.max);
    this.restrictMaxValue(null, this.toValue, this.min, this.max);

    if (this.fromValue > this.toValue) {
      let temp = this.toValue;
      this.toValue = this.fromValue;
      this.fromValue = temp;
    }

    this.isChanged = this.setIsChanged(this.fromValue, this.toValue, this.min, this.max);
    this.setLabel(this.isChanged);

    this.filter.selected = [this.fromValue.toString() + ' - ' + this.toValue.toString()];
    this.filter.valueRangeFilter.selected = [this.fromValue.toString(), this.toValue.toString()];
    this.filter.valueRangeFilter.fromValue = this.fromValue;
    this.filter.valueRangeFilter.toValue = this.toValue;
    this.valueChanged.emit(this.filter);
  }

  ngAfterViewInit() {
    this.isInitialized = true;
    this.setvaluesAndSliderPositions();
  }

  createLocalView() {
    if (this.filter) {
      this.fromValue = this.min;
      this.toValue = this.max;
    }
  }

  setIsChanged(_fromValue: number, _toValue: number, _min: number, _max: number) {
    if (_fromValue !== undefined && _fromValue !== _min && _fromValue !== null) {
      return true;
    }
    if (_toValue !== undefined && _toValue !== _max && _toValue !== null) {
      return true;
    }
    return false;
  }

  setLabel(_isChanged: boolean) {
    if (_isChanged) {
      this._label = String.Format(
        '{0}-{1}',
        this.fromValue ? this.toLocal.transform(this.fromValue) : '',
        this.toLocal ? this.toLocal.transform(this.toValue) : ''
      );
      if (this._label?.length > 0) {
        this.showSelected = true;
      }
    } else {
      this._label = '';
    }
  }

 

  clearAll = () => {
    this.fromValue = this.min;
    this.toValue = this.max;

    this.value = [null, null];
    this.filter.valueRangeFilter.selected = [null, null];
    this.updateSliderConfig();
    this.valueChanged.emit(this.filter);
  };

  setvaluesAndSliderPositions = () => {
    this.fromValue = this.fromValue !== undefined && this.fromValue !== null ? this.fromValue : this.min;
    this.toValue = this.toValue !== undefined && this.toValue !== null ? this.toValue : this.max;

    this.updateSliderConfig();
  };

  updateSliderConfig = () => {
    if (!this.isInitialized) {
      return;
    }
    const sliderConfig = this.getSliderConfig(this.fromValue, this.toValue);
    // if (this.sliderRef) {
    //   this.sliderRef.update(sliderConfig);
    // }
  };

  getSliderConfig = (from: number, to: number) => {
    return {
      min: this.min,
      max: this.max,
      from: from,
      to: to,
      grid_snap: this.filter.valueRangeFilter.grid_snap,
      step: this.filter.valueRangeFilter.step
    };
  };

  onKeyPress(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // space = 32
    if (charCode === 32) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  restrictMinValue(event: any, value: number, min: number, max: number) {
    if (value < min) {
      // Set to min
      this.fromValue = min;
    } else if (value > max) {
      // Set to max
      this.fromValue = max;
    }

    this.filter.selected = [this.fromValue.toString() + ' - ' + this.toValue.toString()];
    this.filter.valueRangeFilter.selected = [this.fromValue.toString(), this.toValue.toString()];
    this.filter.valueRangeFilter.fromValue = this.fromValue;
    this.valueChanged.emit(this.filter);
  }

  restrictMaxValue(event: any, value: number, min: number, max: number) {
    if (value < min) {
      // Set to min
      this.toValue = min;
    } else if (value > max) {
      // Set to max
      this.toValue = max;
    }

    this.filter.selected = [this.fromValue.toString() + ' - ' + this.toValue.toString()]; // Show as Chip
    this.filter.valueRangeFilter.selected = [this.fromValue.toString(), this.toValue.toString()];
    this.filter.valueRangeFilter.toValue = this.toValue;
    this.valueChanged.emit(this.filter);
  }

  onSliderFinish = (slider: any, event: any) => {
    this.fromValue = event.from;
    this.toValue = event.to;
  };
}
